module.exports = __webpack_public_path__ + "media/images/prtimes-6c559fe0c3faad0a15f0eaf6c32c8908.jpg";